module.exports = __webpack_public_path__ + "img/inst-10.f1ea303c.png";